import MyAccount from "./MyAccount";

export default MyAccount;
